import cn from 'classnames';

import { CardContent, type CardContentProps } from '../shared/CardContent';

import styles from './StandardCard.module.css';

export type StandardCardContentProps = CardContentProps;

export const StandardCardContent: React.FC<StandardCardContentProps> = ({
  className,
  ...props
}) => {
  return (
    <div className={styles['standard-card-content-wrapper']}>
      <CardContent
        className={cn(styles['standard-card-content'], className)}
        {...props}
      />
    </div>
  );
};
